import { render } from "./App.vue?vue&type=template&id=489f5233"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=489f5233&lang=css"

import exportComponent from "/Users/kaseyzhuravlev/Desktop/MAJOR_STUDIO_2/fashion-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__